module.exports = __webpack_public_path__ + "static/media/Sigapore-kelvin-zyteng.76005400.jpg";